export default __webpack_public_path__ + "static/media/process.106e01a3.png";